import type { MysteryDetails, MysterySelection, Race } from '@mobi/betslip/types'
import { SetMysteryQuickPickPresetInvestment } from '@core/Areas/Quickbet/signals'
import type { QuickbetSelection } from '@core/Areas/Quickbet/types'
import { handleBetSelection } from '@core/Utils/betting/handleBetSelection'
import { CreateMysterySelection, MysteryQuickPickOptions } from './MysteryTypes'

export function createMysterySelection({
  productCode,
  mysteryOption,
  mysteryType,
  isAlways,
  investmentWin,
  investmentPlace,
  betTypeName,
  raceInformation,
  betType,
}: CreateMysterySelection): QuickbetSelection {
  const race = raceInformation

  const selection: MysterySelection = {
    fixtureId: race.meetingId,
    fixtureDate: race.meetingDate,
    raceNumber: race.raceNumber,
    mysteryType,
    isAlways,
    productCode,
    mysteryOption,
    bets: null,
    metaData: null,
  }
  const selectionDetails: MysteryDetails = {
    race,
    investmentWin,
    investmentPlace,
    productCode,
    mysteryOption,
    betTypeName,
    betType,
  }

  return {
    bettingType: betType,
    selection,
    isEachWayAvailable: false,
    shouldAllowPlaceInvestment: false,
    presetInvestment: betType === 'mystery-quick-pick' ? true : undefined,
    selectionDetails,
  }
}

export const betFromRaceBettingPageQuickPick = (
  selectedKey: string | null,
  raceInformation: Race
): void => {
  if (!selectedKey) {
    return
  }

  const quickPick = MysteryQuickPickOptions.find(qp => qp.uniqueKey === selectedKey)

  if (!quickPick) {
    return
  }
  const {
    productCode,
    mysteryType,
    mysteryOption,
    investment: investmentWin,
    uniqueKey: betTypeName,
    displayPrice,
    isAlways,
  } = quickPick

  const betSelection = createMysterySelection({
    productCode,
    mysteryOption,
    mysteryType,
    isAlways,
    investmentWin,
    investmentPlace: 0,
    betTypeName,
    raceInformation,
    betType: 'mystery-quick-pick',
  })

  openQuickBetMystery(betSelection, displayPrice)
}

export function openQuickBetMystery(selection: QuickbetSelection, displayPrice: number): void {
  handleBetSelection({
    betFlow: {
      location: 'Quickbet',
      options: {
        setUp: () => {
          SetMysteryQuickPickPresetInvestment(displayPrice)
        },
      },
    },
    selections: [selection],
  })
}

export interface MysteryProductPlanBetLine {
  template: string
  poolType: string
  defaultInvestment: number
  isMultiLeg: boolean
}
